import { render, staticRenderFns } from "./NewFreedomCompete.vue?vue&type=template&id=44e113a0&scoped=true&"
import script from "./NewFreedomCompete.vue?vue&type=script&lang=js&"
export * from "./NewFreedomCompete.vue?vue&type=script&lang=js&"
import style0 from "./NewFreedomCompete.vue?vue&type=style&index=0&id=44e113a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e113a0",
  null
  
)

export default component.exports